var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-up",on:{"click":function($event){return _vm.goUp()}}},[_c('button',[_c('fa-icon',{attrs:{"icon":['fas', 'chevron-up']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }